import autoload from "./autoload";
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';
import ShoppingCart from './components/cart/ShoppingCart';

autoload();

window.app = new Vue({
  el: '#vue-cart',

  mixins: [initDom, auth, cart],

  components: {ShoppingCart},
});

// displays the add-to-cart dropdown
require('./app_events');
